export class StarCounter {
  private element: HTMLDivElement;
  private collected = 0;
  private total = 0;

  constructor() {
    this.element = document.createElement('div');
    this.element.id = 'star-counter';
    this.element.style.position = 'absolute';
    this.element.style.top = '10px';
    this.element.style.left = '50%';
    this.element.style.transform = 'translateX(-50%)';
    this.element.style.color = '#ffdd00';
    this.element.style.fontFamily = 'monospace';
    this.element.style.fontSize = '24px';
    this.element.style.textShadow = '0 0 10px #ffdd00, 2px 2px 4px #000';
    this.element.style.pointerEvents = 'none';

    document.body.appendChild(this.element);
    this.update();
  }

  setTotal(total: number): void {
    this.total = total;
    this.collected = 0;
    this.update();
  }

  increment(): void {
    this.collected++;
    this.update();
  }

  getCollected(): number {
    return this.collected;
  }

  getTotal(): number {
    return this.total;
  }

  isComplete(): boolean {
    return this.collected >= this.total && this.total > 0;
  }

  reset(): void {
    this.collected = 0;
    this.update();
  }

  private update(): void {
    this.element.textContent = `★ ${this.collected}/${this.total}`;
  }

  destroy(): void {
    this.element.remove();
  }
}
